import CheckBox from 'ageas-react-component-checkbox'
import Dropdown from 'ageas-react-component-dropdownlist'
import PolicyData from 'ageas-react-component-greybackground'

import { useCallback, useEffect } from 'react'
import { DiscountCampaings } from '../../@types/RunPetisSimulation'
import { t } from '../../i18n'
import { useAnimalStore } from '../../Stores/animalStore'
import { usePaymentStore } from '../../Stores/paymentStore'
import { useSimulatorStore } from '../../Stores/simulatorStore'
import { useGenerateProposalDocumentsStore } from '../../Stores/useGenerateProposalDocumentsStore'
import { useRunPetisSimulationStore } from '../../Stores/useRunPetisSimulationStore'

type CampaignsItems = {
  caption: string
  value: string
}

export const SimulationData = ({
  loading,
  disabled,
}: {
  loading?: boolean
  disabled?: boolean
}) => {
  const { directDebit, setDirectDebit, crossSell, setCrossSell } =
    usePaymentStore()
  const { packsCampaigns, setSelectedPackCampaign, selectedPackCampaign } =
    useRunPetisSimulationStore()
  const {
    setIsRecalculate,
    isRecalculate,
    hasRecalculate,
    setHasRecalculate,
    typeOfPrice,
  } = useSimulatorStore()
  const { isGenerateProposalDocuments } = useGenerateProposalDocumentsStore()
  const { animalsList } = useAnimalStore()

  const removeDuplicatesByCaption = (campaignsList: CampaignsItems[]) => {
    const uniqueItems: CampaignsItems[] = []
    const captionsSet = new Set()

    campaignsList.forEach((item) => {
      if (!captionsSet.has(item.caption)) {
        uniqueItems.push(item)
        captionsSet.add(item.caption)
      }
    })

    return uniqueItems
  }

  const campaignsByPack = () => {
    const campaignsByAnimalAndPackSelected: DiscountCampaings[] = []

    animalsList?.forEach((insuredObject) => {
      const campaignsByInsuredObjectCode = packsCampaigns?.filter(
        (campaign) =>
          campaign.insuredObjectCode === insuredObject.insuredObjectCode &&
          campaign.packId === insuredObject.pack?.packId &&
          (campaign.installmentCode || '')?.toUpperCase() ===
            typeOfPrice.toUpperCase(),
      ) as DiscountCampaings[]

      campaignsByAnimalAndPackSelected.push(
        ...(campaignsByInsuredObjectCode || []),
      )
    })

    return [
      packsCampaigns?.find((packCampaign) => packCampaign.coverages === null),
      ...campaignsByAnimalAndPackSelected.flat(),
    ]
  }

  const formatterCampaign = removeDuplicatesByCaption(
    campaignsByPack()?.map((packCampaign) => ({
      caption: packCampaign?.additionalText || '',
      value: packCampaign?.id || '',
    })),
  )

  const handleRecalculate = useCallback(() => {
    setHasRecalculate('discountCampaigns', 'directDebit')
  }, [setHasRecalculate])

  const handleCampaign = (id: string) => {
    const campaign = packsCampaigns?.find((item) => item.id === id)

    if (
      selectedPackCampaign?.id === id ||
      (campaign?.coverages === null && !selectedPackCampaign?.id)
    ) {
      return
    }

    if ((id || '')?.length && !isRecalculate) {
      setIsRecalculate(true)
      setHasRecalculate('discountCampaigns', 'campaign')
    } else if (isRecalculate && campaign?.coverages === null) {
      setIsRecalculate(false)
      setHasRecalculate('discountCampaigns', 'campaign')
    }

    setSelectedPackCampaign(campaign || null)
  }

  useEffect(() => {
    if (hasRecalculate) {
      const itemsToRecalculate = Object.values(hasRecalculate).flatMap(
        (item) => item,
      )

      if (itemsToRecalculate.length > 0) {
        setIsRecalculate(true)
      } else {
        setIsRecalculate(false)
      }
    }
  }, [hasRecalculate, setIsRecalculate])

  return (
    <>
      <PolicyData
        id="result-simulation"
        version="2"
        name={t('pages.step2.discountAndCampaign')}
        open={true}
        detail={true}
        showLoading={loading}
        components={
          <div className="container">
            <div className="row">
              {/* <CheckBox
                readOnly={disabledStep}
                id="cross-sell"
                label={t('pages.step2.crossSell')}
                value={crossSell}
                onValueChanged={(key: any, value: any) => setCrossSell(value)}
              /> */}
              <CheckBox
                readOnly={isGenerateProposalDocuments || disabled}
                id="debit-direct"
                label={t('pages.step2.directDebt')}
                value={directDebit}
                onValueChanged={(key: any, value: any) => {
                  setDirectDebit(value)
                  handleRecalculate()
                }}
              />
            </div>
            <div className="row">
              <Dropdown
                noSort
                readOnly={isGenerateProposalDocuments || disabled}
                id="campaign-select"
                name="campaign-select"
                label={t('pages.step2.campaign')}
                value={selectedPackCampaign?.id || ''}
                colorTheme="blue"
                version="2"
                options={formatterCampaign}
                onValueChanged={(id: any, value: any) => handleCampaign(value)}
              />
            </div>
          </div>
        }
      />
    </>
  )
}
